/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
export type SocketEventPayload<T = any> = {
  type: string,
  data: T,
  broadcast: T
}

export type SocketEmitPayload<T = any> = {
  action: string,
  data: T,
  seq?: number
} | {
  event: string,
  data: T,
}

export const socket = (url: string) => {
  const subscribersMap = new Map<string, Set<Function>>();

  const on = <T extends Function,>(type: string, callback: T) => {
    const subscribersSet = subscribersMap.get(type) || new Set();

    subscribersSet.add(callback)

    subscribersMap.set(type, subscribersSet)

  }

  const connect = () => {
    const instance = new WebSocket(url);

    const emit = (payload: SocketEmitPayload<any>) => {
      instance.send(JSON.stringify({
        ...payload,
        seq: 'seq' in payload ? payload.seq : 1
      }))
    }

    instance.addEventListener("message", (event) => {
      try {
        const parsedData = JSON.parse(event.data) as SocketEventPayload;

        if (parsedData.type) {
          const subscribers = subscribersMap.get(parsedData.type);

          subscribers?.forEach(subscriber => subscriber({ ...parsedData.broadcast, data: parsedData.data, }))
        }
      } catch (e) {
        console.error("Socket data parse error:", e)
      }
    })

    return Object.assign(instance, {
      emit
    })
  }


  return {
    on,
    connect
  }
}